import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
const GA_ID = 'G-KQKQ10E4Z3';
export function App() {
  useEffect(() => {
    // Google Analytics only
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);
    const inlineScript = document.createElement('script');
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_ID}');
    `;
    document.head.appendChild(inlineScript);
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(inlineScript);
    };
  }, []);
  return <LandingPage data-id="element-0" />;
}